import React from "react";
import "./styles/app.scss";
import Main from "./components/Main";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { Provider } from "react-redux";
import { store } from "./store/config/configureStore";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <CssBaseline />
          <Main />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
